import React from "react";
import styles from "./Cardlist.scss";

const CardList: React.FC<React.ComponentPropsWithoutRef<"div">> = (props) => {
  return <div className={styles.container} {...props} />;
};
export default CardList;
